const agent = [
  //经纪人-看板
  {
    path: 'agentBoard',
    name: 'agentBoard',
    meta: {
      atName: 'agentBoard'
    },
    component: () => import('@/viewsTemplate/agent/agentBoard'),
  },
  //看板-总览
  {
    path: 'agentOverview',
    name: 'agentOverview',
    meta: {
      atName: 'agentOverview'
    },
    component: () => import('@/viewsTemplate/agent/agentOverview'),
  },
  //返佣统计
  {
    path: 'agentRebateData',
    name: 'agentRebateData',
    meta: {
      atName: 'agentRebateData'
    },
    component: () => import('@/viewsTemplate/agent/agentRebateData'),
  },
  //返佣明细
  {
    path: 'agentRebateDetial',
    name: 'agentRebateDetial',
    meta: {
      atName: 'agentRebateDetial'
    },
    component: () => import('@/viewsTemplate/agent/agentRebateDetial'),
  },
  //用户列表
  {
    path: 'agentUserList',
    name: 'agentUserList',
    meta: {
      atName: 'agentUserList'
    },
    component: () => import('@/viewsTemplate/agent/agentUserList'),
  },
  //经纪人列表
  {
    path: 'agentList',
    name: 'agentList',
    meta: {
      atName: 'agentList'
    },
    component: () => import('@/viewsTemplate/agent/agentList'),
  },
  //经纪人角色管理
  {
    path: 'agentRole',
    name: 'agentRole',
    meta: {
      atName: 'agentRole'
    },
    component: () => import('@/viewsTemplate/agent/agentRole'),
  },
  //KV配置
  {
    path: 'agentKvConfig',
    name: 'agentKvConfig',
    meta: {
      atName: 'agentKvConfig'
    },
    component: () => import('@/viewsTemplate/agent/agentKvConfig'),
  },
  //奖励账户
  {
    path: 'agentRewardAccount',
    name: 'agentRewardAccount',
    meta: {
      atName: 'agentRewardAccount'
    },
    component: () => import('@/viewsTemplate/agent/agentRewardAccount'),
  },
  //团队数据
  {
    path: 'agentTeamData',
    name: 'agentTeamData',
    meta: {
      atName: 'agentTeamData'
    },
    component: () => import('@/viewsTemplate/agent/agentTeamData'),
  },
  //直属下级
  {
    path: 'agentDownLevel',
    name: 'agentTeamData',
    meta: {
      atName: 'agentTeamData'
    },
    component: () => import('@/viewsTemplate/agent/agentDownLevel'),
  },
  //用户资产
  {
    path: 'agentUserAssets',
    name: 'agentUserAssets',
    meta: {
      atName: 'agentUserAssets'
    },
    component: () => import('@/viewsTemplate/agent/agentUserAssets'),
  },
    //出入金明细
    {
      path: 'inAndOutDetail',
      name: 'inAndOutDetail',
      meta: {
        atName: 'inAndOutDetail'
      },
      component: () => import('@/viewsTemplate/agent/agentTransferDetail'),
    },
  // 系统管理 => 语言配置 => 多语言列表
  {
    path: "languageService",
    name: "languageService",
    meta: {
      atName: "languageService",
    },
    component: () => import("@/viewsTemplate/systemManagement/languageSet"),
  },

  // 系统管理 => 语言配置 => 多语言编辑
  {
    path: "languageModify",
    name: "languageService",
    meta: {
      atName: "languageService",
    },
    component: () => import("@/viewsTemplate/systemManagement/languageModify"),
  },
  //交易 => 仓位列表
  {
    path: "positionPage",
    name: "positionPage",
    meta: {
      atName: "positionPage",
    },
    component: () => import("@/viewsTemplate/agent/agentPositionList"),
  },
    //交易-普通委托
    {
      path: "orderPage",
      name: "orderPage",
      meta: {
        atName: "orderPage",
      },
      component: () => import("@/viewsTemplate/agent/agentEntrustTab"),
    },
      //返佣-返佣等级
  {
    path: 'agentReturnLevel',
    name: 'agentReturnLevel',
    meta: {
      atName: 'agentReturnLevel'
    },
    component: () => import('@/viewsTemplate/agent/agentReturnLevel'),
  },
]

export default agent
